/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

import {
  Components, Breakpoints, ThemeProps as Prop, GlobalLayoutValues,
  FontFamily,
  FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.UI_SECTION;

export const StyledUiSection = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ $isTransparent, $colorProfile }) => (($isTransparent) ? 'transparent' : themeUtil(Prop.BACKGROUND, CPNT, $colorProfile))};
  transition: 1s background-color linear;

  ${({ scrollOffset }) => ((scrollOffset) ? `
    scroll-behavior: smooth;
    scroll-margin-top: ${scrollOffset}px;
  ` : '')}


  ${({ $backgroundImage, $backgroundCrop }) => $backgroundImage && css`
    background-image: url('${$backgroundImage}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: ${`${$backgroundCrop}%` || 'center'} center;
  `}
`;

export const OuterWrapper = styled.div`
  width: 100%;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({
    $topPadding, $bottomPadding, $sidePadding,
    $topPaddingMobile, $bottomPaddingMobile,
    hasUiFooterAsChild, hasUiHeaderAsChild, hasNoPaddingGrid,
    isMobile, $isWrapperless,
  }) => {
    let topPaddingPx = 50;
    let bottomPaddingPx = 50;

    if (isMobile) {
      // handle top padding
      if ($topPaddingMobile === null) {
        if (hasUiHeaderAsChild || hasNoPaddingGrid) topPaddingPx = 0;
      } else topPaddingPx = $topPaddingMobile;

      // handle bottom padding
      if ($bottomPaddingMobile === null) {
        if (hasUiFooterAsChild || hasNoPaddingGrid) bottomPaddingPx = 0;
      } else bottomPaddingPx = $bottomPaddingMobile;
    } else {
      // handle top padding
      if ($topPadding === null) {
        if (hasUiHeaderAsChild || hasNoPaddingGrid) topPaddingPx = 0;
      } else topPaddingPx = $topPadding;

      // handle bottom padding
      if ($bottomPadding === null) {
        if (hasUiFooterAsChild || hasNoPaddingGrid) bottomPaddingPx = 0;
      } else bottomPaddingPx = $bottomPadding;
    }

    if ($isWrapperless) {
      topPaddingPx = 0;
      bottomPaddingPx = 0;
    }

    return `
      margin: ${topPaddingPx}px ${$sidePadding}% ${bottomPaddingPx}px;
      margin: ${topPaddingPx}px round(nearest, ${$sidePadding}%, 1px) ${bottomPaddingPx}px;
    `;
  }}

  .temp-section-header {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG10, undefined, undefined)};
    text-align: center;
  }

  ${Breakpoints.desktopOnly(css`
    .trapezoid-overlay {
      transform: skewX(-20deg);
      pointer-events: none;
      position: absolute;
      border: 1px black solid;
      width: 100%;
      height: 100%;
      z-index: 10;
    }

    .trapezoid-overlay + .section-inner .ui-column, .trapezoid-overlay + .section-inner .ui-column > ui-image {
      padding: 0;

      .ui-image {
        padding: 0;

        img {
          margin: 0;
        }
      }

      .ui-html {
        padding-left: 100px;
      }
    }
  `)}
`;

export const MaxWidthWrapper = styled.div`
  display: flex;
  width: 100%;
  ${({ $isIgnoreMaxWidth }) => (!$isIgnoreMaxWidth) && `max-width: ${GlobalLayoutValues.DESKTOP.WRAPPER_MAX}px;`};
`;

export const ComponentWrapper = styled.div`
  width: 100%;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;

  .loader-404 {
    height: auto;
    width: auto;
  }
`;
